import { useMutation } from 'react-query'
import { apiClient } from '../../../../api/apiClient'
import { EXPORT_API_URL } from '../../../../constants/constants'
import { TExportRequest, TExportResponse } from '../definitions'

const exportResult = async (data: TExportRequest): Promise<TExportResponse> => await apiClient
  .post(EXPORT_API_URL, data)
  .then((response) => response?.data)

export const EXPORT_RESULT_QUERY_KEY = 'exportResult'

export const useExportResultMutation = () =>
  useMutation({
    mutationKey: [EXPORT_RESULT_QUERY_KEY],
    mutationFn: exportResult
  })
